module.exports = __webpack_public_path__ + "img/bd.4200e8cb.png";